import React, { FC, useEffect, useState } from "react";
import Button, { BUTTON_VARIANTS } from "components/shared/Button/Button";
import Form from "./Form/Form";
import NoCard from "./NoCard/NoCard";
import { useAppSelector } from "toolkit/hooks";
import { replacePhone, snackWrapper } from "helpers";
import { User } from "../EmployeeCard/model";
import cn from "classnames";
import styles from "./UserCard.module.sass";
import { userAPI } from "libs/apiClient/User";

const initial: User = {
	id: 0,
	employee: { id: 0, firstName: "", lastName: "", middleName: "", position: { id: 0, name: "" } },
	firstName: "",
	lastName: "",
	middleName: "",
	email: "",
	phone: "",
};

const UserCard: FC<{ disabled: boolean }> = ({ disabled }) => {
	const selectedEmployee = useAppSelector((state) => state.employess.selectedEmployee);

	const [state, setState] = useState<typeof selectedEmployee.user>(initial);

	const [disabledForm, setDisabledForm] = useState<boolean>(true);

	useEffect(() => {
		if (selectedEmployee && selectedEmployee.user) {
			setState({
				...selectedEmployee.user,
				phone: replacePhone(selectedEmployee.user.phone, "to_front"),
			});
		}
	}, [selectedEmployee]);

	const changeField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setState((prevState: any) => ({ ...prevState, [name]: value }));
	};

	const onSave = () => {
		const { id, firstName, lastName, middleName, email, phone } = state;
		const payload = {
			firstName,
			lastName,
			middleName,
			email,
			role: 0,
			...(phone && { phone: replacePhone(phone, "to_server") }),
		};
		userAPI
			.userUpdate(id, payload)
			.then(() => {
				setDisabledForm(true);
			})
			.catch((e: any) => {
				if (e.response.data.toLowerCase() === "email is not valid") {
					snackWrapper("error", "Не валидный email");
				}
			});
		// $api
		// 	.put(`/user/${id}`, { ...payload })
		// 	.then(() => {
		// 		setDisabledForm(true);
		// 	})
		// 	.catch((e: any) => {
		// 		if (e.response.data.toLowerCase() === "email is not valid") {
		// 			snackWrapper("error", "Не валидный email");
		// 		}
		// 	});
	};

	return (
		<div className={styles.userCard}>
			<div className={cn("step-header", styles.header)}>
				<div className={styles.title}>Карточка пользователя</div>
				{selectedEmployee?.user ? (
					!disabledForm ? (
						<Button onClick={onSave}>Сохранить</Button>
					) : (
						<Button disabled={disabled} variant={BUTTON_VARIANTS.OUTLINED} onClick={() => setDisabledForm(false)}>
							Изменить информацию
						</Button>
					)
				) : null}
			</div>

			{selectedEmployee?.user ? (
				<Form state={state} changeField={changeField} disabledForm={disabledForm} />
			) : (
				<NoCard />
			)}
		</div>
	);
};

export default UserCard;
